import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/waffers/orange  waffer.png";
import BiscuitImg from "../../../assets/products/waffers/Orange-Waffers.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 6,
  },
  {
    grams: 7,
  },
  {
    grams: 16,
  },
  {
    grams: 18,
  },
];

export default function OrangeWafferProduct() {
  return (
    <>
      <Helmet>
        <title>Orange Waffer – BearBitz | Premium Wafers & Biscuits</title>
        <meta
          name="description"
          content="Explore BearBitz Orange Wafers — zesty orange-flavored crispy wafers with creamy filling. View pack sizes, cartons, and global specs."
        />
        <meta name="keywords" content="Orange Waffer, BearBitz Orange Wafers" />
        <link rel="canonical" href="https://www.bearbitz.in/waffers/orangewaffer" />
        <meta property="og:title" content="Orange Waffer – BearBitz" />
        <meta
          property="og:description"
          content="Delicious orange cream wafer biscuit by BearBitz, designed for premium taste and export standards."
        />
      </Helmet>

      <ProductTemplate
        productTitle="ORANGE"
        productImage={BisImg}
        description="Crisp Layers, Creamy Delight Light, crunchy wafer layers filled with smooth cream in flavors like vanilla, chocolate, strawberry, and more. These biscuits offer a perfect bite of crisp and cream, making them a favorite among kids and teens. Easy to pack, easy to love – ideal for export markets worldwide."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#EF5608"
        sectionBgColor="#FFDAC8"
        productBgcolor="#FEB088"
        tableheadBgcolor="#EF5608"
        tableBgcolor="#FFFAF7"
        footerBgcolor="#EF5608"
      />
    </>
  );
}
